import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & .Main__Container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-top: ${({ headerHeight }) => headerHeight}px;

    & > div:first-child {
      flex: 1 0 auto;
      position: relative;
    }
  }
`
